import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class GetWxAuthSign extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.TRIPARTITE
		this.url = '/wx/getWxAuthSign'
		this.desc = '获取小程序授权签名'
	}
}

export class GetWxScheme extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.TRIPARTITE
		this.url = '/wx/getWxScheme'
		this.desc = '获取小程序scheme码接口'
	}
}

export class PdAirportGetUnionPayTn extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.TRIPARTITE
		this.url = '/pdAirport/pdAirportGetUnionPayTn'
		this.desc = '浦东机场获取云闪付交易号'
	}
}

export class GetWxUrlLink extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.TRIPARTITE
		this.url = '/wx/getWxUrlLink'
		this.desc = '获取小程序URL_LINK接口'
	}
}

export class GetChannelUrl extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/common/getChannelUrl'
		this.desc = '获取渠道跳转地址'
	}
}
